import { StyleSheet } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';

// Register a universal font that supports all languages
const getStaticFontPath = () => {
  const publicUrl = import.meta.env.VITE_PUBLIC_URL || '';
  const cleanPublicUrl = publicUrl.replace(/\/$/, '');
  return `${cleanPublicUrl}/static/font`;
};

const STATIC_PATH = getStaticFontPath();

// Register Noto Sans which supports English, Japanese, and Chinese
Font.register({
  family: 'NotoSansUniversal',
  fonts: [
    {
      src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Regular.ttf`,
      fontWeight: 'normal',
    },
    {
      src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Bold.ttf`,
      fontWeight: 'bold',
    },
    {
      src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Light.ttf`,
      fontWeight: 'light',
    },
    {
      src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Medium.ttf`,
      fontWeight: 'medium',
    },
  ],
});

export const styles = StyleSheet.create({
  invoiceHeader: {
    fontSize: 12,
    textAlign: 'center',
    color: 'grey',
  },
  invoiceFirstPage: {
    fontSize: 10,
    paddingTop: 45,
    paddingBottom: 60,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
  invoiceTitleContainer: {
    marginTop: 10,
  },
  invoiceTitleText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
    fontWeight: 'bold',
    letterSpacing: 4,
    fontSize: 22,
    textAlign: 'center',
  },
  invoiceDateContainer: {
    flexDirection: 'row',
    marginTop: 12,
    justifyContent: 'flex-end',
  },
  invoiceDateLabel: {
    font: 10,
    fontFamily: 'NotoSansUniversal', // Use universal font
    fontWeight: 'normal',
  },
  invoiceDateText: {
    font: 12,
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceTo: {
    // flexDirection: 'row',
    marginTop: 15,
    padding: 5,
  },
  invoiceToText: {
    fontSize: 15,
    fontFamily: 'NotoSansUniversal', // Use universal font
    fontWeight: 'bold',
  },
  invoiceToText2: {
    fontSize: 12,
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceFrom: {
    flexDirection: 'row',
    // marginTop: 15,
    justifyContent: 'flex-end',
  },
  invoiceFromText: {
    fontSize: 10,
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceGreetings: {
    flexWrap: 'wrap',
    marginTop: 10,
  },
  invoiceGreetingsText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceDetailedTitle: {
    flexWrap: 'wrap',
    marginTop: 10,
  },
  invoiceDetailedTitleText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
    fontSize: 12,
    fontWeight: 'bold',
  },
  invoiceTotalAmount: {
    flexWrap: 'wrap',
    marginTop: 10,
  },
  invoiceTotalAmountText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
    fontSize: 12,
    fontWeight: 'bold',
  },
  invoiceDetailedAmount: {
    marginTop: 15,
  },
  invoiceDetailedAmountListTable: {
    flexWrap: 'wrap',
    marginTop: 10,
    borderWidth: 1,
    // borderColor: '#bff0fd',
  },
  invoiceDetailedAmountListHeader: {
    flexDirection: 'row',
    // borderBottomColor: '#bff0fd',
    backgroundColor: '#bff0fd',
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 20,
    fontWeight: 'bold',
    flexGrow: 1,
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceDetailedAmountListNo: {
    width: '5%',
  },
  invoiceDetailedAmountListItem: {
    width: '55%',
  },
  invoiceDetailedAmountListItem1: {
    width: '30%',
  },
  invoiceDetailedAmountListItem2: {
    width: '25%',
  },
  invoiceDetailedAmountListCount: {
    width: '10%',
    textAlign: 'right',
    paddingRight: 8,
  },
  invoiceDetailedAmountListItemUnitPrice: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
  invoiceDetailedAmountListItemTotalPrice: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
  invoiceDetailedAmountListRow: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    fontWeight: 'bold',
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceDetailedAmountListRowBorderTop: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    fontWeight: 'bold',
    fontFamily: 'NotoSansUniversal', // Use universal font
    borderTopWidth: 1,
    // borderBottomColor: '#bff0fd',
  },
  invoiceDetailedAmountListRowBorderBottom: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    fontWeight: 'bold',
    fontFamily: 'NotoSansUniversal', // Use universal font
    borderBottomWidth: 1,
    // borderBottomColor: '#bff0fd',
  },
  invoiceDetailedAmountListFooter: {
    flexWrap: 'warp',
    paddingLeft: 2,
    borderWidth: 1,
  },
  invoiceDetailedAmountListFooterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    fontWeight: 'bold',
    fontFamily: 'NotoSansUniversal', // Use universal font
    borderTopWidth: 1,
    // borderBottomColor: '#bff0fd',
    backgroundColor: '#bff0fd',
  },
  invoiceDetailedAmountListFooterLabel: {
    width: '85%',
    // textAlign: 'left',
    paddingLeft: 8,
  },
  invoiceDetailedAmountListFooterText: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 8,
  },
  invoicePaymentMethod: {
    flexWrap: 'wrap',
    marginTop: 5,
    // borderWidth: 1,
  },
  invoicePaymentMethodTitle: {
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoicePaymentMethodText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
    paddingLeft: 10,
  },
  invoiceRemarks: {
    // height: 40, // when height < 40, it's too small to show the text
    // flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 5,
    // borderWidth: 1,
    // borderBottomColor: '#bff0fd',
    // alignItems: 'center',
  },
  invoiceRemarksTitle: {
    fontFamily: 'NotoSansUniversal', // Use universal font
  },
  invoiceRemarksText: {
    fontFamily: 'NotoSansUniversal', // Use universal font
    paddingLeft: 10,
  },
  invoiceRemarksLeft: {
    width: '15%',
    fontSize: 15,
    fontFamily: 'NotoSansUniversal', // Use universal font
    borderRightColor: '#bff0fd',
    padding: 5,
  },
  invoiceRemarksRight: {
    width: '85%',
    fontSize: 10,
    fontFamily: 'NotoSansUniversal', // Use universal font
    padding: 5,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});
